import React from 'react';
import PropTypes from 'prop-types';
import { Upload, Icon } from 'antd';
import styles from './style.less';

// const beforeUpload = (file) => {
//   const isLt10M = file.size / 1024 / 1024 < 10;
//   if (!isLt10M) {
//     message.error('Зурагны хэмжээ 10MB ээс бага байх ёстой');
//   }
//   return isLt10M;
// };


class ImageWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  setUrl = (string) => {
    if (!string) return undefined;

    let object;

    try {
      // object = JSON.parse(string);
      object = string;

      if (object) {
        object.forEach((entry, key) => {
          if (entry.response && entry.response.data) {
            object[key].url = `https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload${entry.response.data.link}`;
            object[key].thumbUrl = `https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload${entry.response.data.dump_link}`;
          }
        });
      }
    } catch (e) {
      console.log({ e });
      return undefined;
    }
    return object;
  }
  // url("https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload/upload/56f416ca-d05c-4a59-9a77-66e93563b3e5.jpg")


  prefixValue = (value) => {
    if (!value) return undefined;

    return value.map(item => JSON.stringify(item));
  }

  handleChange = ({ fileList }) => {
    // fileList.forEach((entry, key) => {
    //   fileList[key] = JSON.stringify(entry);
    // if (entry.response && entry.response.data) {
    //   fileList[key].url = `https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload${entry.response.data.link}`;
    //   fileList[key].thumbUrl = `https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload${entry.response.data.dump_link}`;
    // } else {
    //   fileList[key].url = entry.thumbUrl;
    // }
    // });
    console.log({ fileList });
    this.forceUpdate();
    this.props.onChange(fileList);
  }

  render() {
    console.log('his.props.value, ', this.props.value);
    const options = {
      action: '/rest/store_product/upload_image',
      multiple: true,
      accept: 'image/*',
      listType: 'picture-card',
      // onRemove: (file) => {
      //   this.setState(({ fileList }) => {
      //     const index = fileList.indexOf(file);
      //     const newFileList = fileList.slice();
      //     newFileList.splice(index, 1);
      //     return {
      //       fileList: newFileList,
      //     };
      //   });
      // },
      // beforeUpload: (file) => {
      //   console.log('beforeUpload: ', file);
      //   file.url = file.response && file.response.data.link;
      //   return file;
      // },
      fileList: this.props.value,
      onChange: this.handleChange,
    };
    return (
      <div className={styles.satUploader}>
        <Upload {...options}>
          <div>
            <Icon type="plus" />
            <div className="ant-upload-text">Нэмэх</div>
          </div>
        </Upload>
      </div>
    );
  }
}

ImageWidget.defaultProps = {
  value: [],
};

ImageWidget.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default ImageWidget;



// WEBPACK FOOTER //
// ./src/components/OrderForm/Widgets/ImageWidget/index.js